import { Homepage } from "@/components/homepage";
import { SEO } from "@/components/seo";

const Index = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AffinityAim",
    "url": "https://www.affinityaim.com",
    "logo": "https://www.affinityaim.com/logo.png",
    "description": "We build custom web apps, sales prospecting tools, and workflow automation for B2B companies and sales teams. Fixed price. Fast delivery. Based in Norway.",
    "foundingDate": "2023",
    "email": "post@affinityaim.com",
    "address": { "@type": "PostalAddress", "addressCountry": "NO" },
    "sameAs": [
      "https://linkedin.com/company/affinityaim"
    ]
  };

  return (
    <>
      <SEO
        title="AffinityAim | Custom Apps & Business Tools for B2B Companies"
        description="We build custom web apps, sales prospecting tools, and workflow automation for B2B companies and sales teams. Fixed price. Fast delivery. Based in Norway."
        canonical="https://www.affinityaim.com/"
        keywords="custom web apps, sales prospecting tools, workflow automation, B2B software, internal business apps, client portals"
        schema={organizationSchema}
      />
      <Homepage />
    </>
  );
};

export default Index;

